(function() {
  let flagsLoaded = false;
  const countryFlagsUrl = document.currentScript?.dataset.countryFlagsUrl;

  function loadCountryFlagsCSS() {
    if (flagsLoaded || !countryFlagsUrl) return;
    flagsLoaded = true;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = countryFlagsUrl;
    document.head.appendChild(link);
  }

  // If a visible selector already renders a flag, load the sprite after the
  // page becomes interactive so the current country icon is not missing.
  if (document.querySelector('.country-flags')) {
    if (document.readyState === 'complete') {
      loadCountryFlagsCSS();
    } else {
      window.addEventListener('load', loadCountryFlagsCSS, { once: true });
    }
  }

  // Attach click handler to all country-selector buttons
  document.addEventListener('click', function(e) {
    const button = e.target.closest('button[aria-controls^="popover-localization-form-country"]');
    if (button) {
      loadCountryFlagsCSS();
    }
  }, { capture: true });
})();
